import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class WhitePaperProvider {

  getWhitePaper() {
    return graphqlClient.query({
      query: gql`
        query {
          whitePaper {
            file
          }
        }
      `,
    });
  }
}

export default new WhitePaperProvider();
